import React from 'react';
import PropTypes from 'prop-types';
import { Row } from '../structure/row';
import { Cell, CENTER, LEFT } from '../structure/cell';
import { FormattedPrice } from '../../price/formatted_price';
import { show } from '../../../actions/clearance_info_light_box_actions';

export function Sale(props) {
    return (
        <Row className="products-price">
            <Cell side={LEFT} colSpan={2}>
                <div className="sale-price">
                    {props.clearance &&
                        <span onClick={show}
                            className="sale-price__tag sale-price__tag--clearance cursor-pointer">Clearance</span>
                    }
                    {!!props.salePrice &&
                        <span className="sale-price__tag sale-price__tag--sale">Sale</span>
                    }
                    {!!props.salePrice &&
                        <span className="sale-price__text">
                            Was{' '}
                            <FormattedPrice
                                price={props.salePrice}
                                currencyIsoCode={props.currencyIsoCode}
                                className="sale-price__price"
                            />
                        </span>
                    }
                </div>
            </Cell>
        </Row>
    );
}

Sale.propTypes = {
    salePrice: PropTypes.number.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
    clearance: PropTypes.bool,
};

Sale.defaultProps = {
    clearance: false,
};
